import { z } from 'zod';
import { LandingPagesBuilderSchemaV2 } from './originalSchemas';
import { catalog } from '@playbook-technologies/common-schemas/lib/catalog';

/**
 * CTA (Call To Action) schema
 */
const CTASchema = catalog.FeaturedOffer.schema.shape.cta1
  .unwrap()
  .unwrap()
  .extend({
    enabled: z.boolean().optional(),
    text: z.string().optional(),
    link: z.string().optional(),
  });

/**
 * Featured Offer Section schema
 */
const featuredOfferFormSchema = catalog.FeaturedOffer.schema.extend({
  offerId: z.number({
    required_error: 'Please select an offer',
    invalid_type_error: 'Please select an offer',
  }),
  headlineText: z.string().min(1, 'Headline text is required'),
  description: z.string().default(''),
  listedItems: z.array(z.string()).optional().default([]),
  coverImage: z.string().min(1, 'Cover image is required'),
  cta1: CTASchema.optional(),
  cta2: CTASchema.optional(),
});

/**
 * Offers Carousel Section schema
 */
const offersCarouselFormSchema = catalog.OffersCarousel.schema.extend({
  title: z.string().min(1, 'Title is required'),
  subtitle: z.string().optional().default(''),
  offerIds: z.array(z.number()).default([]),
});

const [introduction, heroVideo, heroImage, ...optionalSections] =
  LandingPagesBuilderSchemaV2.shape.sections.element.options;
const optionalSectionOptions = optionalSections.flatMap<
  (typeof optionalSections)[number]['options'][number]
>((section) => section.options);

export const ExtendedLandingPagesBuilderSchema =
  LandingPagesBuilderSchemaV2.extend({
    sections: z.array(
      z.union([
        introduction,
        heroVideo,
        heroImage,
        ...optionalSectionOptions,
        featuredOfferFormSchema,
        offersCarouselFormSchema,
      ]),
    ),
  });
